import { Component, ElementRef, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatTableDataSource, MatTabChangeEvent, MatAutocompleteTrigger } from '@angular/material';
import { IProcedureComponent, IprocedureLevels, IprocedureSides, IprocedureTypes } from 'src/app/models/IProcedures';
import { ProceduresService } from 'src/app/Services/NewVisitNote/procedures.service';
import { InputDialogComponent } from '../input-dialog/input-dialog.component';
declare var $: any;
export interface DialogData {
  procedureName: string;
  procSide: string;
  procType: string;
  procLevels: string;
  procCode: string;
}
@Component({
  selector: 'app-patient-procedures',
  templateUrl: './patient-procedures.component.html',
  styleUrls: ['./patient-procedures.component.css']
})
export class PatientProceduresComponent implements OnInit {
  procTypesdata: IprocedureTypes[] = [];
  procSidesdata: IprocedureSides[] = [];
  procLevelsdata: IprocedureLevels[] = [];
  procedurename;
  procedureSide; procedureType; procedureLevels; procCode;
  patientprocedureForm: FormGroup;
  @ViewChildren('otherInput') otherInput: QueryList<ElementRef>;
  constructor(public dialogRef: MatDialogRef<PatientProceduresComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private proService: ProceduresService, private formBuilder: FormBuilder, public dialog: MatDialog, private toastr: ToastrService) {
    this.loadAllProcedureDropdowns();
    if (data != null) {
      this.procedurename = data.procedureName;
      this.procedureSide = data.procSide;
      this.procedureType = data.procType;
      this.procedureLevels = data.procLevels;
      this.procCode = data.procCode;
    }
  }

  ngOnInit() {
    this.patientprocedureForm = this.formBuilder.group({
      procedureType: ['',],
      procedureSide: [''],
      procedureLevels: ['',]
    });

    $(document).click(function (event) {
      if (event.target.id != "allproviderfocus") {
        if (event.target.id != "procedurefocus") {
          var container = $("#allLevelsFocushide");
          if (!container.is(event.target) && !container.has(event.target).length) {
            container.hide();
          }
          if (event.target.id == "providersfocus") {
            $("#providersfocushide").show();
          }
        }
        if (event.target.id != "providersfocus") {
          var container = $("#providersfocushide");
          if (!container.is(event.target) && !container.has(event.target).length) {
            container.hide();
          }
          if (event.target.id == "allLevelsFocus") {
            $("#allLevelsFocushide").show();
          }
        }
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  loadAllProcedureDropdowns() {
    this.procLevelsdata = [];
    forkJoin(
      this.proService.getProcedureTypes(),
      this.proService.getProcedureSides(),
      this.proService.getProcedureLevels({ partId: 0, levelName: '', isInsert: 0 }),
      this.proService.getProcedureCptCodes()).subscribe(([types, sides, levels, cptcode]: any) => {
        this.procTypesdata = types.sort((a, b) => a.typeName.localeCompare(b.typeName));
        this.procSidesdata = sides.sort((a, b) => a.sideName.localeCompare(b.sideName));
        this.procLevelsdata = levels.sort((a, b) => a.levelName.localeCompare(b.levelName));
      }
        , (err: any) => {
          console.log(err);

        }
      );
  }
  levelslst: IprocedureLevels[] = [];
  levelsList: IprocedureLevels[]
  AllProcWithLevels(procName: string) {
    ;
    var proclevels;
    if (procName.toLowerCase().includes('thoracic')) {
      if (procName.toLowerCase().includes('cervicothoracic')) {
        ;
        proclevels = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.levelName.startsWith('C') || attr.levelName.startsWith('T'));
      } else {
        proclevels = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.levelName.startsWith('T'));

      }
    } else if (procName.toLowerCase().includes('lumbar')) {
      if (procName.toLowerCase().includes('thoracolumbar')) {
        ;
        proclevels = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.levelName.startsWith('T') || attr.levelName.startsWith('L'));
      } else {
        proclevels = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.levelName.startsWith('L'));
      }
    } else if (procName.toLowerCase().includes('cervical')) {
      proclevels = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.levelName.startsWith('C'));
    }
    // Newly added 
    else if (procName.toLowerCase().includes('lumbosacral')) {
      proclevels = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.levelName.startsWith('L') || attr.levelName.startsWith('S'));
    }
    else if (procName.toLowerCase().includes('thoracolumbar')) {
      ;
      proclevels = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.levelName.startsWith('T') || attr.levelName.startsWith('L'));
    } else if (procName.toLowerCase().includes('cervicothoracic')) {
      ;
      proclevels = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.levelName.startsWith('C') || attr.levelName.startsWith('T'));
    }
    else proclevels = this.procLevelsdata;
    return proclevels;

  }
  CurrEncProcSideChange(e, element: IProcedureComponent, type, i) {

    var sideName = "";
    if (type == 'focus') {
      var procside = this.procSidesdata.filter(x => x.sideName == e.target.value)
      if (procside.length > 0) {
        sideName = procside[0].sideName
      } else {
        $('#side' + i).val('');
        sideName = ''
      }
    } else {
      sideName = e.source.value
    }
  }

  openDialogregion(): void {
    const dialogRef = this.dialog.open(InputDialogComponent, {
      width: '350px',
      height: '160px',
      data: { headerText: 'Please enter the Level', inputValue: '' }
    });
    let tempCollection = [];
    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        var checkList = this.procLevelsdata.filter(x => x.levelName === result)
        if (checkList.length > 0) {

          this.toastr.error('This Level already Exists.')
          return false;
        }
        else {
          let partId = 0;
          if (result[0].toLowerCase() == 'c') {
            partId = 1;
          }
          else if (result[0].toLowerCase() == 't') {
            partId = 2;
          } else if (result[0].toLowerCase() == 'l') {
            partId = 3;
          }

          let req = { partId: partId, levelName: result, isInsert: 1 };
          this.proService.getProcedureLevels(req).subscribe(
            results => {

              let _IdVal = 0;
              results.forEach(item => {
                _IdVal = item.levelId
                tempCollection.push({ levelName: item.levelName, isActive: item.isActive, levelId: item.levelId, partId: item.partId, procedureId: item.procedureId, selected: item.selected });
              });
              this.procLevelsdata = tempCollection;
              //this.procLevelsdata.filter(x => x.selected = false)
              this.selectedList.forEach(element => {      
              this.procLevelsdata.filter(x => x.levelId == element.levelId).map(y => y.selected = true)
               });
              this.toastr.success(result +" "+ "Levels Added Succsessfully");
            });
        }
      }
    });
  }

  CurrEncProcTypeChange(e, element: IProcedureComponent, type) {

    var typeName = "";
    if (type == 'focus') {
      var procside = this.procTypesdata.filter(x => x.typeName == e.target.value)
      if (procside.length > 0) {
        typeName = procside[0].typeName
      } else {
        typeName = ''
      }
    } else {
      typeName = e.source.value
    }

  }

  onaddprocedure() {
    this.data.procedureName = this.procedurename;
    this.data.procLevels = this.patientprocedureForm.value.procedureLevels;
    this.data.procSide = this.patientprocedureForm.value.procedureSide;
    this.data.procType = this.patientprocedureForm.value.procedureType;
    this.dialogRef.close(this.data);
  }

  selectedList: IprocedureLevels[] = [];
  selected = '';
  selectedName = '';
  providerSelectionChanged(providerselect) {
    var titems =   this.selectedList;
    this.selectedList = providerselect.selectedOptions.selected.map(item => item.value);
    //var t = [...titems, ...this.selectedList];
    //this.selectedList = [...new Set(t)]
    
    // selecteditems.push(this.selectedList);
    // this.selectedList[0].levelName = selecteditems;
    this.procLevelsdata.filter(x => x.selected = false)
    this.selectedList.forEach(element => {      
      this.procLevelsdata.filter(x => x.levelId == element.levelId).map(y => y.selected = true)
    });

    this.selected = '';
    this.selectedName = '';
    for (let index = 0; index < this.selectedList.length; index++) {
      
      this.selected += this.selectedList[index].levelId + ';';
      this.selectedName += this.selectedList[index].levelName + '; ';
    }

    if (this.selectedList.length != 0) {
      this.selectedName = this.selectedName.substring(0, this.selectedName.length - 1);
      
    }
    this.patientprocedureForm.patchValue({
      procedureLevels: this.selectedName 
    })

  }
  islevelselected(evnname, selcsv) {
    let levelvals = selcsv.split("; ");
    return levelvals.includes(evnname);
  }
  onSelectionChanged(event, type: string) {
    setTimeout(() => {
      if (event !== null && event !== undefined) {
        $(event.target).prev().trigger('focus');
        $("#allLevelsFocushide").show();
      }
    }, 100);
  }
  
  focusOutFunction(evn) {
    if (evn.keyCode === 9) {
      $('#allLevelsFocushide').hide()

    } else if (evn.keyCode === 40 && evn.target.id == "allLevelsFocus") {
      $('#pvlistoption0').focus();
    }
  }
}
